import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickAssignEmployeeComponent } from './quick-assign-employee.component';
import { SharedModule } from 'app/shared/shared.module';



@NgModule({
  declarations: [
    QuickAssignEmployeeComponent
  ],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [
    QuickAssignEmployeeComponent
  ]
})
export class QuickAssignEmployeeModule { }
